import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=d1cdfc2e&scoped=true&"
import script from "./Containers.vue?vue&type=script&lang=js&"
export * from "./Containers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cdfc2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/forge/portmann.hmd.lv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout,VPagination,VSnackbar,VSpacer,VTextField,VTooltip})
